const UPDATE_VERTICAL_MENU_COLLAPSED = (state, val) => {
  state.isVerticalMenuCollapsed = val
}

export default {
  UPDATE_VERTICAL_MENU_COLLAPSED,
}
